import { myLessongroupsIcon, toClassicIcon } from "common/defaultIcons";
import { ROUTES } from "shared/constants";
import { myLessongroupsTransitionMeetingFragment } from "meetings/advisory/routes/fragments";
import { myLessonGroupsStudentMeetingFragment } from "meetings/student-meeting/routes/fragments";
import { myLessongroupsPortfolioFragment } from "portfolio/routes/fragments";
import { storeToRefs } from "pinia";
import { useModuleStore } from "store/modules/moduleStore.js";

const routes = [
  {
    name: "myLessongroups",
    path: "/my-lessongroups",
    redirect: () => {
      const moduleStore = useModuleStore();
      const { redirectToCorrectModule } = storeToRefs(moduleStore);
      return { name: redirectToCorrectModule.value.myLessongroupsRoute };
    },
    meta: {
      title: `Mijn lesgroepen`,
      role: "teacher",
      // Verborgen uit het hoofdmenu (route blijft direct bereikbaar)
      isMenuItem: false,
      menuSection: "main",
      settingRequired: ["studentMeeting", "learningObjectives", "portfolio"],
      menuOrder: 5,
      roleRequired: [
        "webmaster",
        "manager",
        "organizer",
        "teamleader",
        "decaan",
        "teacher",
      ],
      icon: toClassicIcon(myLessongroupsIcon),
    },
    children: [
      ...myLessonGroupsStudentMeetingFragment,
      ...myLessongroupsTransitionMeetingFragment,
      ...myLessongroupsPortfolioFragment,
      {
        path: "learning-objectives",
        name: ROUTES.MY_LESSONGROUPS_LEARNING_OBJECTIVES,
        component: () => import("pages/my-lessongroups/LearningObjectives.vue"),
        meta: {
          title: "Leerdoelen",
          sublabel: "bèta",
          isMenuItem: true,
          menuSection: "main",
          settingRequired: ["learningObjectives"],
          roleRequired: [
            "webmaster",
            "manager",
            "organizer",
            "teamleader",
            "decaan",
            "teacher",
          ],
        },
      },
    ],
  },
];

export default routes;
